import { useQuery } from "@tanstack/react-query";
import { Card, Col, Row, Statistic, Typography } from "antd";
import { STATUS_LABELS, type GuideStatus } from "@/features/guides/api";
import { getAdminStats } from "./api";

export function DashboardPage() {
  // P3.5:一次请求拿全看板数据(替代原 4 次 listGuides 分页凑数)
  const { data, isLoading } = useQuery({
    queryKey: ["admin-stats"],
    queryFn: getAdminStats,
  });
  const byStatus = data?.guides.by_status ?? {};

  return (
    <div>
      <Typography.Title level={4} style={{ marginBottom: 16 }}>工作台</Typography.Title>
      <Row gutter={16}>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic title="指南总数" value={data?.guides.total ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic
              title={`待审批(${STATUS_LABELS["Apply" as GuideStatus]})`}
              value={byStatus.Apply ?? 0}
              valueStyle={{ color: "#fa8c16" }}
            />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic title="已批准(进入共享)" value={byStatus.Approved ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic title="已定级" value={byStatus.Leveled ?? 0} valueStyle={{ color: "#52c41a" }} />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic title="评审单总数" value={data?.evaluations.total ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card loading={isLoading}>
            <Statistic
              title="评审已提交待处理"
              value={data?.evaluations.submitted ?? 0}
              valueStyle={{ color: "#fa8c16" }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
